export enum ResponseStatus {
    Success = "Success",
    Error = "Error",
    NotFound = "NotFound",
    UnAuthorized = "UnAuthorized",
    InvalidDataCode = 400,
    ReviewerSignaturesRequired = "ReviewerSignaturesRequired",
}
